import { useState } from "react";
import "./editorialForms.css";

export default function TutorialForm({ data, onChange }) {
  const [stepInput, setStepInput] = useState("");

  const categories = [
    "Programacao",
    "Design",
    "Fotografia",
    "Video",
    "Culinaria",
    "DIY",
    "Beleza",
    "Fitness",
    "Musica",
    "Artesanato",
    "Jardinagem",
    "Outros",
  ];

  const difficulties = [
    { id: "beginner", name: "Iniciante" },
    { id: "intermediate", name: "Intermediario" },
    { id: "advanced", name: "Avancado" },
  ];

  const handleAddStep = () => {
    if (stepInput.trim()) {
      onChange({
        ...data,
        steps: [...(data?.steps || []), { title: stepInput.trim(), description: "" }],
      });
      setStepInput("");
    }
  };

  const handleRemoveStep = (index) => {
    onChange({
      ...data,
      steps: (data?.steps || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form tutorial_form">
      <div className="editorial_form_section">
        <label>
          Titulo do Tutorial <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Como criar um site do zero"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="O que o usuario vai aprender..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || "beginner"}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tempo Estimado</label>
          <input
            type="text"
            placeholder="Ex: 30 minutos"
            value={data?.estimatedTime || ""}
            onChange={(e) => onChange({ ...data, estimatedTime: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Requisitos</label>
          <input
            type="text"
            placeholder="Ex: Conhecimento basico de HTML"
            value={data?.requirements || ""}
            onChange={(e) => onChange({ ...data, requirements: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Passos do Tutorial ({(data?.steps || []).length})
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddStep}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Titulo do passo..."
          value={stepInput}
          onChange={(e) => setStepInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddStep()}
        />
        <div style={{ marginTop: "8px" }}>
          {(data?.steps || []).map((step, i) => (
            <div key={i} className="variant_row">
              <input type="text" value={`${i + 1}. ${step.title}`} disabled />
              <button
                type="button"
                className="remove_variant_btn"
                onClick={() => handleRemoveStep(i)}
              >
                x
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Materiais Necessarios</label>
        <textarea
          placeholder="Liste os materiais ou ferramentas necessarias..."
          value={data?.materials || ""}
          onChange={(e) => onChange({ ...data, materials: e.target.value })}
          rows={2}
        />
      </div>

      <div className="editorial_form_section">
        <label>Configuracoes</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasVideo"
              checked={data?.hasVideo || false}
              onChange={(e) =>
                onChange({ ...data, hasVideo: e.target.checked })
              }
            />
            <label htmlFor="hasVideo">Inclui video</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasDownloads"
              checked={data?.hasDownloads || false}
              onChange={(e) =>
                onChange({ ...data, hasDownloads: e.target.checked })
              }
            />
            <label htmlFor="hasDownloads">Arquivos para download</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip tutorial_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z" />
        </svg>
        <span>
          Crie tutoriais passo a passo para ensinar habilidades especificas.
          Adicione imagens e videos para ilustrar.
        </span>
      </div>
    </div>
  );
}
